import { makeStyles, Theme } from '@material-ui/core/styles'

export interface ProfileInfoStyleProps {
  bottomBarHeight: number
}
export const profileInfoStyle = makeStyles<Theme, ProfileInfoStyleProps>(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    marginLeft: theme.spacing(2)
  },
  figure: {
    marginTop: theme.spacing(0.2),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    width: '100%',
    overflowX: 'hidden',
    overflowY: 'hidden',
    '& .boring-container': {
      cursor: 'pointer',
      '& rect:hover': {
        strokeWidth: 2
      }
    }
  },
  progress: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-around',
    paddingTop: theme.spacing(8),
    fontSize: '0.8rem',
    color: theme.palette.geoColors.text.light
  },
  legend: {
    width: 250,
    height: props => props.bottomBarHeight - 45,
    overflowY: 'scroll',
    overflowX: 'hidden',
    marginTop: theme.spacing(0.2),
    paddingTop: theme.spacing(5),
    paddingLeft: theme.spacing(2),
    borderLeftColor: theme.palette.geoColors.text.light,
    borderLeftWidth: 1,
    borderLeftStyle: 'solid'
  },
  crosshairContainer: {
    position: 'absolute',
    top: 0,
    pointerEvents: 'none'
  },
  crosshairHorizontal: {
    height: 1,
    width: '100%',
    position: 'absolute',
    background: theme.palette.common.black
  },
  crosshairVertical: {
    height: '100%',
    width: 1,
    position: 'absolute',
    background: theme.palette.common.black
  },
  crosshairValueXCard: {
    position: 'absolute',
    width: 50,
    bottom: -28
  },
  crosshairValueYCard: {
    position: 'absolute',
    width: 35,
    left: -54
  },
  crosshairValueX: {
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    width: '100%',
    background: theme.palette.geoColors.contextBar.dark,
    borderRadius: 3
  },
  crosshairValueY: {
    padding: theme.spacing(0.5),
    width: 35,
    background: theme.palette.geoColors.contextBar.dark,
    borderRadius: 3
  },
  crosshairValue: {
    margin: 0,
    fontSize: 10,
    textAlign: 'center'
  },
  profileWrapper: {
    width: '100%'
  },
  triangleTop: {
    content: '',
    position: 'absolute',
    top: -5,
    left: 15,
    borderTop: 'none',
    borderRight: '10px solid transparent',
    borderLeft: '10px solid transparent',
    borderBottom: '10px solid',
    borderBottomColor: theme.palette.geoColors.contextBar.dark
  },
  triangleRight: {
    content: '',
    position: 'absolute',
    top: 0,
    right: -17,
    borderTop: '10px solid transparent',
    borderRight: 'none',
    borderLeft: '10px solid',
    borderLeftColor: theme.palette.geoColors.contextBar.dark,
    borderBottom: '10px solid transparent'
  }
}))
